import React from 'react';
import { ICarouselSlide } from '../../../../../types';
import VideoCard from '../../../../videoCard/videoCard';

function CarouselVideoSlide(props: ICarouselSlide) {
    const { video, className, isFullScreen, has3DView, debug, slideIndex, currentSlideIndex } = props;
    if (!video) {
        return null;
    }
    
    return (
        <VideoCard
            className={className}
            srcSet={video.srcSet}
            poster={video.poster}
            ariaLabel={video.ariaLabel}
            isFullScreen={isFullScreen}
            has3DView={has3DView}
            debug={debug}
            loadingMode={slideIndex > 0 ? 'external' : 'eager'}
            startLoading={currentSlideIndex === slideIndex}
            loop
        />
    )
}

export default CarouselVideoSlide;
